import moment from "moment";

export function getTimeLeftInFreeTrial(freeTrialExpiresAt) {
  const now = moment();
  const expiry = moment(freeTrialExpiresAt);

  if (!freeTrialExpiresAt || expiry.isBefore(now)) {
    return {
      days: 0,
      hours: 0,
      minutes: 0,
      isExpired: true,
      formattedTime: "Free Plan",
      statusColor: "bg-[#A1A1AA] text-white",
    };
  }

  const days = expiry.diff(now, "days");
  const hours = expiry.diff(now, "hours") - days * 24;
  const minutes =
    expiry.diff(now, "minutes") - days * 24 * 60 - hours * 60;

  const totalHours = days * 24 + hours + (minutes > 0 ? 1 : 0);
  const formattedTime =
    days > 0
      ? `${days} ${days === 1 ? "day" : "days"} remaining`
      : hours > 1
        ? `${hours} hours remaining`
        : "<1 hour remaining";

  const statusColor =
    totalHours > 0 && totalHours <= 72
      ? "bg-red-100 text-red-600 dark:bg-red-900/20 dark:text-red-400"
      : totalHours > 0 && totalHours <= 120
        ? "bg-yellow-100 text-yellow-600 dark:bg-yellow-900/20 dark:text-yellow-400"
        : "bg-cyan-500 text-white";

  return {
    days,
    hours,
    minutes,
    isExpired: false,
    formattedTime,
    statusColor,
  };
}
